import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_TRANSLATION } from '@/graphql/vocabulary';
import { GET_TRANSLATION_MSB } from '@/graphql/mutations/vocabulary';
import { bizmatesApi } from '@/utils/bizmatesApi';
import qs from 'qs';

import logger from '@/modules/Logger';

export const GetTranslationService = {
  msb: async (word, lessonId, programId) => {
    logger.debug(`[Vocabulary][Translation] Fetched translation from MSB GraphQL endpoint`, {
        operation: 'vocabulary:get-translation'
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.mutate({
      mutation: GET_TRANSLATION_MSB,
      fetchPolicy: 'no-cache',
      variables: {
        word,
        lesson_id: lessonId,
        program_id: programId
      }
    });

    if (data?.translation) {
      return data.translation;
    } else {
      logger.error(`[Vocabulary][Translation] Empty result from translation MSB GraphQL endpoint`, {
        operation: 'vocabulary:get-translation',
        event_type: 4,
        word,
        lesson_id: lessonId,
        program_id: programId
      });
    }
  },

  mbti: async (word, lessonId, programId) => {
    logger.debug(`[Vocabulary][Translation] Fetched translation from MBTI GraphQL endpoint`, {
        operation: 'vocabulary:get-translation'
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.query({
      query: GET_TRANSLATION,
      fetchPolicy: 'no-cache',
      variables: {
        word,
        lesson_id: lessonId,
        program_id: programId
      }
    });

    if (data?.translation) {
      return data.translation;
    } else {
      logger.error(`[Vocabulary][Translation] Empty result from translation MBTI GraphQL endpoint`, {
        operation: 'vocabulary:get-translation',
        event_type: 4,
        word,
        lesson_id: lessonId,
        program_id: programId
      });
    }
  },

  legacy: async (word, lessonId, programId) => {
    logger.debug(`[Vocabulary][Translation] Fetched translation from legacy endpoint`, {
        operation: 'vocabulary:get-translation'
    });

    let result = null;

    await bizmatesApi.post(
      'vocabulary/translation',
      qs.stringify({
        word,
        lesson_id: lessonId,
        program_id: programId
      }),
      {},
      response => {
        result = response.data;
      },
      error => {
        console.log(error);
      }
    );

    return result;
  }
};
